export default __webpack_public_path__ + "static/media/Vs.bd91ed29.png";